export type IconBaseProps = {
  width?: string;
  height?: string;
  fill?: string;
};

export const defaultIconProps = (props: IconBaseProps) => ({
  width: props.width || '100%',
  height: props.height || '100%',
  fill: props.fill || 'currentColor',
});
